export const setActiveLanguage = (payload) => ({type: "SET_ACTIVE_LANGUAGE", payload });

export const setIndex = (payload) => ({type: "SET_INDEX", payload });